import { isEmpty } from "lodash";
import { MIN_PASSWORD_LENGTH } from "../constants/auth";

const minLength = min => (value, message) => value && value.length < min ? !isEmpty(message) ? message : `Must be ${min} characters or more` : undefined;

export const validatePasswordLength = value => minLength(MIN_PASSWORD_LENGTH)(value, "Password is too short");